import React from 'react';
import { Box, Typography } from '@material-ui/core';

import { useStyles } from '../../styles';

interface HeadCellProps {
  title: string;
}

export default function HeadCell(props: HeadCellProps) {
  const { title } = props;
  const classes = useStyles();

  return (
    <Box className={classes.content}>
      <Typography variant="subtitle2" className={classes.boldText}>
        {title}
      </Typography>
    </Box>
  );
}
